// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pm-2";
export var chatLink = "_pm-0";
export var chatText = "_pm-1";